/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { z } from 'zod'

const CodeExchangeState = z.object({
  path: z.string().optional()
})
interface CodeExchangeState extends z.infer<typeof CodeExchangeState> {}

export class CodeExchangeStateHelpers {
  static fromPath(path: string): CodeExchangeState {
    return { path }
  }

  static toJSONString(state: CodeExchangeState) {
    return JSON.stringify(state)
  }

  static readJSONString(jsonString: string): CodeExchangeState | null {
    try {
      const parsedJsonString = JSON.parse(jsonString)
      return CodeExchangeState.parse(parsedJsonString)
    } catch (error) {
      return null
    }
  }
}
